import React, { useEffect, useState } from "react";
import {
  SortableContainer,
  SortableElement,
  sortableHandle,
} from "react-sortable-hoc";
import { arrayMoveImmutable } from "array-move";
import ReactQuill from "react-quill";
import { stripHtml } from "./sharedUtils";
const quillModules = {
  toolbar: [
    [{ header: [2, 3, 4, 5, 6, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ align: [] }],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link", "image"],
    ["clean"],
  ],
};

const quillFormats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "align",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
];

const DragHandle = sortableHandle(() => (
  <div className="fm-move">
    <i className="sl sl-icon-cursor-move"></i>
  </div>
));

const SortableItem = SortableElement(({ faq, onChange, onDelete }) => {
  return (
    <tr
      key={`${faq.id}`}
      className="pricing-list-item pattern ui-sortable-handle"
    >
      <td>
        <DragHandle />
        <div className="fm-input pricing-name">
          <input
            className="form-input"
            type="text"
            placeholder="Question"
            value={`${faq.question || ""}`}
            onChange={(e) => onChange({ ...faq, question: e.target.value })}
          />
        </div>
        <div className="fm-input pricing-ingredients">
          {/* <textarea placeholder="Description"></textarea> */}
          <ReactQuill
            // theme="bubble"
            theme="snow" 
            value={`${faq.answer || ""}`}
            onChange={(answer) => onChange({ ...faq, answer })}
            modules={quillModules}
            formats={quillFormats}
          />
        </div>

        <div className="fm-close">
          <a
            className="delete"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              return onDelete(faq);
            }}
          >
            <i className="fa fa-remove"></i>
          </a>
        </div>
      </td>
    </tr>
  );
});

const SortableList = SortableContainer(
  ({ items, onChangeItem, onDeleteItem }) => {
    return (
      <tbody className="ui-sortable">
        {items.map((item, index) => (
          <SortableItem
            key={`item-${item.id}-${index}`}
            index={index}
            faq={item}
            onChange={(faq) => onChangeItem(index, faq)}
            onDelete={(faq) => onDeleteItem(index, faq)}
          />
        ))}
      </tbody>
    );
  }
);

const FormFaqs = (props) => {
  const { setFieldValue } = props;
  const [faqs, setFaqs] = useState(props.values.faqs || [{}]);
  const handleAddOne = (e) => {
    e.preventDefault();
    setFaqs([...faqs, {}]);
  };
  const handleOnSort = ({ oldIndex, newIndex }) => {
    const newFaqs = arrayMoveImmutable(faqs, oldIndex, newIndex);
    console.log("handleOnSort", newFaqs, faqs);
    setFaqs(newFaqs);
    setFieldValue("faqs", newFaqs);
  };

  const handleChangeItem = (idx, faq) => {
    console.log(idx, faq);
    const newFaqs = [...faqs];
    newFaqs[idx] = { ...faq };
    setFaqs([...newFaqs]);
    setFieldValue("faqs", newFaqs);
  };
  const handleDeleteItem = (idx, faq) => {
    const newFaqs = [...faqs];
    newFaqs.splice(idx, 1);
    setFaqs([...newFaqs]);
    setFieldValue("faqs", newFaqs);
  };
  useEffect(() => {
    if (props.values && props.values.faqs != faqs) {
      setFaqs(props.values.faqs || []);
    }
  }, [props.values, props.values.faqs]);
  return (
    <React.Fragment>
      <div className="add_utf_listing_section margin-top-45">
        <div className="utf_add_listing_part_headline_part">
          <h3>
            <i className="sl sl-icon-tag"></i> FAQ
          </h3>
        </div>
        <div className="row">
          <div className="col-md-12">
            <table id="utf_pricing_list_section">
              <SortableList
                useDragHandle
                items={faqs}
                onSortEnd={handleOnSort}
                onChangeItem={handleChangeItem}
                onDeleteItem={handleDeleteItem}
              />
            </table>
            <a
              href="#"
              onClick={handleAddOne}
              className="button add-pricing-list-item"
            >
              Add Item
            </a>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default FormFaqs;
